import React from 'react';
import { Progress } from 'semantic-ui-react';

// Progress Bar Component
const ProgressBar = ({ uploadState, percentUploaded }) => (
  uploadState && (
    <Progress 
      className="progress_bar"
      percent={percentUploaded}
      progress
      indicating
      size="medium"
      inverted
    />
  )
);

export default ProgressBar;